module.exports = __webpack_public_path__ + "static/media/play_i.b32c8c6c.svg";